export default "__VITE_PUBLIC_ASSET__bb01df42__"